import React from 'react';
import { Button, ButtonProps } from './Button';

export type ItemProps = {
  display?: boolean;
  message?: string;
  customLabel?: string;
} & ButtonProps;

export const Item: React.FC<ItemProps> = ({
  action,
  content,
  display = true,
  message,
  label,
  route,
  externalLink,
}) => (
  <>
    {display && message ? (
      <Button
        action={action}
        label={message}
        route={route}
        content={content}
        externalLink={externalLink}
      />
    ) : null}
    {display && !message ? (
      <Button action={action} label={label} route={route} content={content} />
    ) : null}
  </>
);
